import React, { Component, PropTypes } from 'react';
import InputTextField from 'components/common/InputTextField';
import { SANITIZATION_TYPES } from '../../../common/sanitizationTypes';
import { themeOrConfigCodeSanitizeRegex } from '../../../../constants';

class AddContentPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            themelevel: this.props.selected,
            hotel: this.props.hotel,
            baseTheme: this.props.baseTheme,
            name: this.props.name,
            code: this.props.code,
            updated: this.props.updated,
            comments: '',
            themeCode: '',
            selectedTheme: '',
            status: false,
            isDefault: false
        };
    }

    render() {
        return (
            <div className="col-xs-12">
                <h3>Copy a Theme</h3>
                <p>To add a theme, choose an existing theme, then save it with a new name.</p>
                <div id="add-theme-level" className="row">
                    <div id="add-theme-name-theme" className="col-xs-12">
                        <h4 className="pull-left">Save as</h4>
                        <InputTextField
                            name="theme-name"
                            sparkInputProps={{
                                label: 'Theme name*',
                                errorMessage:
                                    !this.props.name && this.props.isValidationShown ? 'Field is required' : ''
                            }}
                            placeholder="Theme name*"
                            value={this.props.name}
                            onChange={this.props.setName}
                        />
                        <InputTextField
                            name="theme-code"
                            sparkInputProps={{
                                label: 'Theme code*',
                                errorMessage:
                                    !this.props.code && this.props.isValidationShown ? 'Field is required' : ''
                            }}
                            placeholder="Theme code*"
                            value={this.props.code}
                            onChange={this.props.setCode}
                            sanitizationType={SANITIZATION_TYPES.REGEXP}
                            sanitizeRegExp={themeOrConfigCodeSanitizeRegex}
                        />
                        <InputTextField
                            sparkInputProps={{ label: 'Comments', softMaxLength: 1000 }}
                            placeholder="Comments..."
                            name="add-theme-commentbox"
                            value={this.props.comments}
                            sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                            replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                            onChange={this.props.setComments}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

AddContentPanel.propTypes = {
    selected: PropTypes.string,
    population: PropTypes.array,
    dispatchValue: PropTypes.func,
    hotels: PropTypes.array,
    availableThemes: PropTypes.array,
    isValidationShown: PropTypes.bool
};

export default AddContentPanel;



// WEBPACK FOOTER //
// ./src/components/pages/manage/manageTheme/AddContentPanel.js